/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/camelcase */
/** ============================ */
/*  This file was autogenerated  */
/*  with `npm run codegen`       */
/* ============================= */

import { gql } from "@apollo/client";
import * as ApolloReactCommon from "@apollo/client";
import * as ApolloReactHooks from "@apollo/client";

import * as Types from "../../../../../api/types.generated";
export type FindRegistrationAttendeeByEmailQueryVariables = Types.Exact<{
  email: Types.Scalars["String"];
  eventId: Types.Scalars["Int"];
}>;

export type FindRegistrationAttendeeByEmailQuery = {
  users: Array<Pick<Types.User, "id" | "email" | "name" | "legal_name">>;
  eventAttendees: Array<
    Pick<Types.EventAttendee, "id" | "user_id" | "role" | "badge_code">
  >;
  claims: Array<
    Pick<Types.Claim, "id"> & {
      stage: Pick<Types.Stage, "slug">;
      fields_HACKTHENORTH2026_APPLICATIONS: {
        answers: {
          rsvp_preferred_name: Pick<
            Types.StringFieldAnswerTypeWrapper,
            "value"
          >;
          rsvp_legal_name: Pick<Types.StringFieldAnswerTypeWrapper, "value">;
          rsvp_preferred_pronouns: Pick<
            Types.StringArrayFieldAnswerTypeWrapper,
            "value"
          >;
          rsvp_accessibility_needs: Pick<
            Types.StringFieldAnswerTypeWrapper,
            "value"
          >;
          rsvp_swag_shirt_type: Pick<
            Types.StringFieldAnswerTypeWrapper,
            "value"
          >;
          rsvp_swag_shirt_size: Pick<
            Types.StringFieldAnswerTypeWrapper,
            "value"
          >;
          rsvp_swag_shirt_accomodations: Pick<
            Types.StringFieldAnswerTypeWrapper,
            "value"
          >;
        };
      };
    }
  >;
};

export const FindRegistrationAttendeeByEmailDocument = gql`
  query FindRegistrationAttendeeByEmail($email: String!, $eventId: Int!) {
    users(take: 1, where: { email: { equals: $email, mode: insensitive } }) {
      id
      email
      name
      legal_name
    }
    eventAttendees(
      where: {
        AND: [
          { event_id: { equals: $eventId } }
          { user: { is: { email: { equals: $email, mode: insensitive } } } }
        ]
      }
    ) {
      id
      user_id
      role
      badge_code
    }
    claims(
      take: 1
      where: {
        AND: [
          {
            pipeline: {
              is: { slug: { equals: "hackthenorth2026-applications" } }
            }
          }
          { user: { is: { email: { equals: $email, mode: insensitive } } } }
        ]
      }
    ) {
      id
      stage {
        slug
      }
      fields_HACKTHENORTH2026_APPLICATIONS {
        answers {
          rsvp_preferred_name {
            value
          }
          rsvp_legal_name {
            value
          }
          rsvp_preferred_pronouns {
            value
          }
          rsvp_accessibility_needs {
            value
          }
          rsvp_swag_shirt_type {
            value
          }
          rsvp_swag_shirt_size {
            value
          }
          rsvp_swag_shirt_accomodations {
            value
          }
        }
      }
    }
  }
`;

/**
 * __useFindRegistrationAttendeeByEmailQuery__
 *
 * To run a query within a React component, call `useFindRegistrationAttendeeByEmailQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindRegistrationAttendeeByEmailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindRegistrationAttendeeByEmailQuery({
 *   variables: {
 *      email: // value for 'email'
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useFindRegistrationAttendeeByEmailQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    FindRegistrationAttendeeByEmailQuery,
    FindRegistrationAttendeeByEmailQueryVariables
  >
) {
  return ApolloReactHooks.useQuery<
    FindRegistrationAttendeeByEmailQuery,
    FindRegistrationAttendeeByEmailQueryVariables
  >(FindRegistrationAttendeeByEmailDocument, baseOptions);
}
export function useFindRegistrationAttendeeByEmailLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    FindRegistrationAttendeeByEmailQuery,
    FindRegistrationAttendeeByEmailQueryVariables
  >
) {
  return ApolloReactHooks.useLazyQuery<
    FindRegistrationAttendeeByEmailQuery,
    FindRegistrationAttendeeByEmailQueryVariables
  >(FindRegistrationAttendeeByEmailDocument, baseOptions);
}
export type FindRegistrationAttendeeByEmailQueryHookResult = ReturnType<
  typeof useFindRegistrationAttendeeByEmailQuery
>;
export type FindRegistrationAttendeeByEmailLazyQueryHookResult = ReturnType<
  typeof useFindRegistrationAttendeeByEmailLazyQuery
>;
export type FindRegistrationAttendeeByEmailQueryResult =
  ApolloReactCommon.QueryResult<
    FindRegistrationAttendeeByEmailQuery,
    FindRegistrationAttendeeByEmailQueryVariables
  >;
